import { Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import LoginBox from './loginBox.jsx';
import Signup from './signup.jsx';
import ForgotPassword from './forgotPassword.jsx';
import { useState } from 'react';
import { loginRequest } from '../../auth/authConfig.js';
import { clearCache } from '../../auth/authService.js';

const Login = () => {
  const { instance } = useMsal();
  const [view, setView] = useState('login');
  const handleLogin = async () => {
    clearCache('error');
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="loginPage">
        <div className="login-container">
          <div className="loginTextBox">
            <div className="loginImg">
              <img src="/assets/images/loginImg.png" alt="CRM" />
            </div>
            <div className="login-content">
              <div className="login-inner">
                <div className="logoBox">
                  <Link className="logo" alt="LeadTrack" title="LeadTrack" to="/">
                    <img src="/assets/images/LeadTrack-logo-white.svg" alt="LeadTrack" />
                  </Link>
                  <span>Powering Connections with Intelligence.</span>
                  <div className="tagline-rule"></div>
                </div>

                {/* <h1>Effortlessly Manage your Team and Operations</h1> */}
                <h1> Manage your Team & Operations - effortlessly </h1>
                {/* <p>Login to access your LeadTrack and manage your team</p> */}

                <div className="auth-section">
                  <div className="auth-section-label">Sign in with credentials</div>
                  {view === 'login' && (
                    <LoginBox onSignup={() => setView('signup')} onForgot={() => setView('forgot')} />
                  )}
                  {view === 'signup' && <Signup onLogin={() => setView('login')} />}
                  {view === 'forgot' && <ForgotPassword onLogin={() => setView('login')} />}
                </div>

                <div className="or-divider"><span>or</span></div>

                {/* <div className="auth-section"> */}
                  <div className="auth-section-label">Single Sign-On</div>
                  <button className="ms-login-btn" onClick={handleLogin}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-label="Microsoft"
                      role="img"
                      viewBox="0 0 512 512"
                    >
                      <rect width="512" height="512" rx="15%" fill="none" />
                      <path d="M75 75v171h171v-171z" fill="#f25022" />
                      <path d="M266 75v171h171v-171z" fill="#7fba00" />
                      <path d="M75 266v171h171v-171z" fill="#00a4ef" />
                      <path d="M266 266v171h171v-171z" fill="#ffb900" />
                    </svg>
                    <span>Continue with Microsoft</span>
                  </button>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
